import Breadcrumb from '@/components/breadcrumb';
import { Button } from '@/components/ui/button';
import { useStore } from '@nanostores/react';
import { PlusIcon } from 'lucide-react';
import { NewWorkspaceDrawer } from './components/NewWorkspaceDrawer';
import { WorkspaceListing } from './components/WorkspaceListing';

export type ManageWorkspacesProps = {
  organizationId: string;
};

export const ManageWorkspaces = ({ organizationId }: ManageWorkspacesProps) => {
  const [showDrawer, setShowDrawer] = useState(false);

  const org = useStore($org);

  const pages = [
    {
      label: org?.name || 'Organizations',
      href: org?.name
        ? `/organization/${org?.id}/workspaces`
        : '/organizations',
    },
    {
      label: 'Workspaces',
      href: `/organization/${org?.id}/workspaces`,
    },
  ];

  return (
    <div>
      {/* Breadcrumb */}
      <h3 className="m-0 flex-1 p-0">
        <Breadcrumb pages={pages} />
      </h3>

      {/* Page Header with actions */}
      <div className=" mt-2 flex items-center justify-between space-y-2">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">Workspaces</h2>
          <p className="text-muted-foreground">
            {`List of workspaces for ${org?.name}.`}
          </p>
        </div>
        <div className="flex items-center space-x-2">
          <Button onClick={() => setShowDrawer(true)}>
            <PlusIcon className="mr-2 h-4 w-4" /> Add New
          </Button>
        </div>
      </div>

      {/* Workspace list */}
      <div className="mt-4 max-w-4xl">
        <WorkspaceListing organizationId={org?.id || organizationId} />
      </div>

      {/* Create New Organization Drawer */}
      <NewWorkspaceDrawer
        open={showDrawer}
        setOpen={setShowDrawer}
        organizationId={org?.id || organizationId}
      />
    </div>
  );
};
